module.exports = __webpack_public_path__ + "img/3-1.d453af5f.png";